// @flow

import { get, sortBy } from 'lodash';

import { type Plan } from '@zapier/common-utils';

export default (plans: Array<Plan>): Array<Plan> =>
  sortBy(plans, plan =>
    get(plan, 'allowCompanies')
      ? 999999999
      : get(plan, 'allow_teams')
      ? 999999998
      : get(plan, 'amount')
  );
